<template>
  <div>
    <span class="item" @click="toggle">
      <v-icon>{{ hidden ? 'mdi-chevron-right' : 'mdi-chevron-down' }}</v-icon>
      <strong v-if="highlight">{{ title }}</strong>
      <span v-else>{{ title }}</span>
    </span>
    <div v-if="!hidden">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleCollapsibleSection',
  props: {
    title: String,
    openByDefault: {
      default: false
    },
    onOpen: Function,
    highlight: Boolean
  },
  data() {
    return {
      hidden: this.openByDefault ? false : true
    }
  },
  updated() {
    if (this.onOpen && !this.hidden) {
      this.onOpen()
    }
  },
  methods: {
    toggle() {
      this.hidden = !this.hidden
    }
  }
}
</script>

<style scoped>
span.item {
  display: flex;
  align-items: center;
  padding: 14px 14px 0 0;
  cursor: pointer;
  margin-bottom: 24px;
}
.theme--dark .v-icon {
  color: #ffffff;
}
</style>
